import { CollecttotalindiandataService } from './../services/collecttotalindiandata.service';
import { CollectindiadataService } from './../services/collectindiadata.service';
import { Component, OnInit, Output } from '@angular/core';
import { EventEmitter } from 'events';
import {Chart} from 'node_modules/chart.js';
@Component({
  selector: 'app-countriwiseindia',
  templateUrl: './countriwiseindia.component.html',
  styleUrls: ['./countriwiseindia.component.css']
})
export class CountriwiseindiaComponent implements OnInit {
  data: any[];
  idData: any;
  constructor (public collectindiadataService: CollectindiadataService, public collecttotalindiandataService: CollecttotalindiandataService) {
    this.collectindiadataService.getData().subscribe( (data) => {
      this.data = data;
    });
    this.collecttotalindiandataService.getData().subscribe( (data) => {
      this.idData = data;
      console.log(this.idData);
      this.createChart();
    });

  }

  ngOnInit(): void {
  }
  createChart(){
    var myDoughnutChart = new Chart('mychart', {
      type: 'pie',
      data: {
        labels: ['Confirmed', 'Active', 'Recovered', 'Deaths'],
        datasets: [{
            data: [this.idData.confirmed, this.idData.active, this.idData.recovered, this.idData.deaths],
            backgroundColor: [
                'rgba(255, 0, 0, 0.8)',
                'rgba(255, 108, 0, 0.8)',
                'rgba(77, 255, 0, 0.8)',
                'rgba(58, 51, 59, 0.8)',
            ],
            // borderColor: [
            //   'rgba(255, 0, 0, 0.9)',
            //   'rgba(255, 108, 0, 0.9)',
            //   'rgba(77, 255, 0, 0.9)',
            //   'rgba(58, 51, 59, 0.9)',
            // ],
            borderWidth: 0.5
        }],
        options: {responsive : true,
          aspectRatio: 1,

        },
      },

      });
    }

}
